const GREY = {
  0: "#FFF",
  50: '#F7FAFC',

  100: '#F3F6F8',
  200: '#EEF2F5',
  300: '#E2E8F0',
  400: '#94A3B8',
  500: '#64748B',
  600: '#475569',
  700: '#334155',
  800: '#1E293B',
  900: '#13212F',
}

const YELLOW = {
  50: '#FFF9E8',
  100: '#FFF8E1',
  200: '#FEEECC',
  300: '#FEEECC',
  400: '#FFECB4',
  500: '#FFCB32',
  600: '#F9AB00',
  700: '#BF8F01',
  800: '#685313',
  900: '#403003',
}

const RED = {
  50: '#FEF5F6',
  100: '#FDECEA',
  200: '#FBC1C2',
  300: '#F89897',
  400: '#F46E6F',
  500: '#F24546',
  600: '#D93025',
  700: '#ED1112',
  800: '#7E090A',
  900: '#621B16',
}

const GREEN = {
  50: '#E6F8EF',
  100: '#E6F4EA',
  200: '#9DE5BE',
  300: '#99E3BA',
  400: '#67D599',
  500: '#35C778',
  600: '#34A853',
  700: '#028B3D',
  800: '#1E4620',
  900: '#012E16',
}

const BLUE = {
  50: '#E6EEF4',
  100: '#B3CDDD',
  200: '#80ACC7',
  300: '#669BBB',
  400: '#337AA5',
  500: '#1A6A99',
  600: '#00598E',
  700: '#003E63',
  800: '#002439',
  900: '#00121C',//'#0F245E',
}

const BUTTON = {
  default: BLUE[600],
  hover: BLUE[700],
  pressed: BLUE[800],
}

const PRIMARY = {
  // SIPP-832: `primary.light` = BLUE[100] (#B3CDDD). The soft light blue used
  // for the contact support card background and the TEST/PROTECT pill tints
  // on the Recommendations tab. Previously pointed at BLUE[300] (#669BBB) —
  // a medium blue that read as "darker" than the spec intended.
  light: BLUE[100],
  main: BLUE[500],
  dark: BLUE[800],
  // SIPP-821: `primary.darker` = BLUE[700] (#003E63). Used by the Smart Home
  // accent in the plan selection stepper — deliberately a touch lighter than
  // `primary.dark` so the darker-than-dark banner sits above the button color.
  darker: BLUE[700],
  contrastText: GREY[50],
}

const SECONDARY = {
  light: GREY[200],//'#6B7280',
  main: '#475367',
  dark: '#344054',
  contrastText: GREY[50],
}

const INFO = {
  light: BLUE[300],
  main: BLUE[600],
  dark: BLUE[800],
  contrastText: GREY[50],
}

const SUCCESS = {
  light: GREEN[100],
  main: GREEN[600],
  dark: GREEN[800],
  contrastText: '#EDF3F7',
  bgcolor: GREEN[50],
}

const WARNING = {
  light: YELLOW[300],
  main: YELLOW[600],
  dark: YELLOW[800],
  contrastText: GREY[50],
  bgcolor: YELLOW[50],
}

const ERROR = {
  light: RED[100],
  main: RED[600],
  dark: RED[700],
  contrastText: GREY[50],
  emphasisText: RED[900],
  bgcolor: RED[50],
}

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  yellow: YELLOW,
  red: RED,
  green: GREEN,
  blue: BLUE,
  divider: GREY[300],
  background: {
    paper: GREY[0],
    default: GREY[100],
    neutral: GREY[200],
    secondary: "#00121C"
  },
  text: {
    primary: GREY[900],
    secondary: GREY[500],
    disabled: GREY[400],
    light: GREY[50],
  },
  button: BUTTON,
}

export default palette
